import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

import { TableCell } from '../Table';
import type { CompareModelsModalVariant } from './types';

export interface CompareModelsTableCellProps {
  readonly className?: string;
  readonly isLastRow?: boolean;
  readonly variant?: CompareModelsModalVariant;
}

const CompareModelsTableCell = ({
  children,
  className,
  isLastRow,
  variant = { md: 'two_column', lg: 'three_column' },
}: PropsWithChildren<CompareModelsTableCellProps>) => {
  return (
    <TableCell
      className={cx(
        'flex-1 text-sm',
        {
          'pb-6': !isLastRow,
          'md:text-xl': variant.md === 'three_column',
          'md:border-b md:border-gray-300':
            !isLastRow && variant.md === 'three_column',
          'lg:text-xl': variant.lg === 'three_column',
          'lg:border-b lg:border-gray-300':
            !isLastRow && variant.lg === 'three_column',
        },
        className,
      )}
      data-cy="compare-models-table-cell"
    >
      {children}
    </TableCell>
  );
};

export default CompareModelsTableCell;
